import { defineLocale } from "../../registry";

const form = defineLocale({
  ru: {
    "form.save": "Сохранить",
    "form.saving": "Сохранение…",
    "form.unsaved": "Есть несохранённые изменения",
    "form.busy":
      "Другое сохранение ещё выполняется. Повторите через мгновение.",
    "form.pending":
      "Изменение ссылки ждёт подтверждения второго администратора и пока не применено.",
    "form.leave.title": "Уйти без сохранения?",
    "form.leave.body":
      "В редакторе есть несохранённые изменения. Если уйти, они будут потеряны.",
    "form.leave.stay": "Остаться",
    "form.leave.confirm": "Уйти без сохранения",
  },
  en: {
    "form.save": "Save",
    "form.saving": "Saving…",
    "form.unsaved": "Unsaved changes",
    "form.busy": "Another save is still running. Try again in a moment.",
    "form.pending":
      "The link change is awaiting confirmation from a second administrator and is not applied yet.",
    "form.leave.title": "Leave without saving?",
    "form.leave.body":
      "This editor has unsaved changes. If you leave, they will be lost.",
    "form.leave.stay": "Stay",
    "form.leave.confirm": "Leave without saving",
  },
});

export default form;
